'use client';

import { SubmitButton } from 'app/components/SubmitButton';
import { Message } from 'app/types';
import { Alert, Button, Modal } from 'flowbite-react';
import { useState } from 'react';
import { useFormState } from 'react-dom';
import { TiCancel } from "react-icons/ti";
import { cancelGeneration } from './ServerActions';

type CancelGenerationProps = {
    isOwner: boolean,
    jobId: string,
}

const initialMessage: Message | undefined = undefined;

export default function CancelGeneration({ isOwner, jobId }: CancelGenerationProps) {
    const [openModal, setOpenModal] = useState(false);
    const [msg, formAction] = useFormState(cancelGeneration, initialMessage);

    if (!isOwner) {
        return <></>;
    }

    return <>
        <Modal className="bg-white dark:bg-custom-dark" dismissible show={openModal} onClose={() => setOpenModal(false)}>
            <form action={formAction}>
                <div className="border border-neutral-400 dark:border-neutral-600 shadow-md dark:shadow-neutral-600">
                    <Modal.Header className='p-2 bg-gray-100 dark:bg-custom-grey'>
                        <div className='flex flex-row items-center gap-2'>
                            <TiCancel color='red' className='h-6 w-6'/>
                            Cancel generation
                        </div>
                        </Modal.Header>
                    <Modal.Body className="bg-gray-100 dark:bg-custom-grey">
                        <div className="space-y-6">
                            <p><strong>Cancelling stops the creation of the animation.</strong> After cancelling, you will have access to the frames and preview videos created so far (if any), and will be refunded part of the credit cost.</p>
                            <p>Are you sure you want to cancel?</p>
                        </div>
                        {msg &&
                            <div key={msg.timestamp} className='flex flex-row items-center gap-2 px-4 py-2'>
                                <Alert className='rounded-none' color={msg.type}>{msg.message}</Alert>
                            </div>}                            
                    </Modal.Body>
                    <Modal.Footer className="bg-gray-100 dark:bg-custom-grey">
                        <Button className="rounded-none bg-transparent text-black dark:text-white border-black border-solid dark:border-white px-3 py-1 hover:scale-x-110 hover:ease-linear hover:duration-300 mr-2" color="gray" onClick={() => setOpenModal(false)}>Back</Button>
                        <input type="hidden" name="jobId" value={jobId} onChange={() => { }} />
                        <SubmitButton
                            className="rounded-none bg-transparent text-black dark:text-white border-red-500 border-solid dark:border-red-500 px-3 py-1 hover:scale-x-110 hover:ease-linear hover:duration-300"
                            type="submit"><TiCancel color='red' className='mr-2' />Cancel generation</SubmitButton>
                    </Modal.Footer>
                </div>
            </form>
        </Modal>
        <Button color='red' className="items-start rounded-none border border-none bg-transparent text-black dark:text-white hover-bg-red-800 hover:scale-x-110 hover:ease-linear hover:duration-300" size={'xs'} onClick={() => setOpenModal(true)}>
            <TiCancel color='red' className='mr-2' />Cancel
        </Button>
    </>
}

